// TopInfoBar.js
import React from "react";
import "./TopInfoBar.css";

export default function TopInfoBar() {
  return (
    <div className="top-info-bar">
      #314, Shagun Arcade, Vijay Nagar Square, Indore, 452010 , #2nd Branch, Veda Business Park, Bhanwarkua, Indore, 452014
    </div>
  );
}